module.exports = __webpack_public_path__ + "img/bitlabImg2x.693d6a5b.png";